export default "__VITE_ASSET__C92fnoDr__ 100w";